import axios from 'axios'

const URL = 'https://api.openweathermap.org/data/2.5/weather';
const API_KEY = '5e2ca7499002408a25f72265c3489d9a';


export const featchWeather= async(cityname)=>{

    const {data}=await axios.get(URL,{
        params:{
            q:cityname,
            units:'metric',
            APPID:API_KEY
        }
    });
    return data;
}